import React from 'react';

const Chevron = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="9.6" viewBox="0 0 16 9.6">
    <path id="f3d0" d="M15.05,0,16,1.05,8,9.6,0,1.05.95,0,8,7.5Z" transform="translate(0 0)" fill="currentcolor" />
  </svg>
);

export default Chevron;
